const RESIZE_OBSERVER_LOOP_MESSAGES = [
  "ResizeObserver loop completed with undelivered notifications.",
  "ResizeObserver loop limit exceeded"
];

function isResizeObserverLoopError(event) {
  const message = String(event?.message || event?.reason?.message || event?.reason || "");
  return RESIZE_OBSERVER_LOOP_MESSAGES.some((knownMessage) => message.includes(knownMessage));
}

if (typeof window !== "undefined") {
  window.addEventListener("error", (event) => {
    if (!isResizeObserverLoopError(event)) {
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  window.addEventListener("unhandledrejection", (event) => {
    if (!isResizeObserverLoopError(event)) {
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
}
